/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { RisksTabEntrypointProps } from './RisksTab.entrypoint.types.tsx';

import risksTabIssueQueryParameters from './__generated__/RisksTabIssueQuery$parameters.ts';
import type { RisksTabIssueQuery } from './__generated__/RisksTabIssueQuery.graphql.ts';

type RisksTabEntryPointComponent = EntryPointComponent<
	{
		issueQuery: RisksTabIssueQuery;
	},
	Record<string, never>,
	RisksTabEntrypointProps,
	Record<string, never>
>;

export const risksTabEntryPoint: EntryPoint<RisksTabEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForUserVisible<RisksTabEntryPointComponent>(
		/* webpackChunkName: "async-prevention-center-risks-tab" */ './RisksTab.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		issueKey = '',
		cloudId = '',
	}: { issueKey?: string; cloudId?: string } = {}) => ({
		queries: {
			issueQuery: {
				parameters: risksTabIssueQueryParameters,
				variables: {
					issueKey,
					cloudId,
				},
			},
		},
	}),
});
